const testimonials = [
  {
    name: "阿泽",
    role: "五年老用户",
    content: "一直是动漫之家的老用户，换网址那阵子找不回来，还好有这个页面整理入口，一下就能回去追番了。",
  },
  {
    name: "小晚",
    role: "番剧爱好者",
    content: "网页版和 APP 记录同步做得很好，手机缓存离线看，回家用电脑接着追，体验很顺滑。",
  },
  {
    name: "木木",
    role: "漫画党",
    content: "人气番剧推荐准，漫画更新也及时，追更订阅功能对我这种蹲更新的人太友好了。",
  },
];

const values = [
  { icon: "ri-hand-heart-line", title: "陪伴成长", desc: "多年来持续陪伴动漫爱好者，见证无数人的青春与热爱。" },
  { icon: "ri-team-line", title: "热爱同好", desc: "汇聚众多二次元同好，弹幕互动让追番不再孤单。" },
  { icon: "ri-verified-badge-line", title: "内容用心", desc: "番剧与漫画内容持续更新，力求为每位用户带来优质体验。" },
];

export default function About() {
  return (
    <section id="about" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-heart-line"></i> 关于我们
            </span>
            <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">
              动漫之家，一直在你身边
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              动漫之家是一个陪伴众多二次元爱好者的追番与追漫平台，汇集番剧、漫画、资讯与社区互动。
              我们始终坚持用心更新内容、稳定提供服务，希望每一位用户都能在这里找到属于自己的热爱。
              无论官网地址如何更新，我们都希望第一时间帮你找到回「家」的路。
            </p>
            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {values.map((v) => (
                <div key={v.title} className="rounded-xl border border-background-200 bg-background-50 p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                    <i className={`${v.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-3 text-sm font-bold text-foreground-950">{v.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-4">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="rounded-xl border border-background-200 bg-background-50 p-5"
              >
                <div className="flex items-center gap-1 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                  “{t.content}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 text-secondary-900">
                    <i className="ri-user-smile-line text-lg"></i>
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-600">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}